import {
  Component,
  Input,
} from '@angular/core';

@Component({
    selector: 'app-routing-button',
    templateUrl: './routing-button.component.html',
    styleUrls: ['./routing-button.component.scss'],
    standalone: false
})
export class RoutingButtonComponent {
  @Input() routerLink: any[] | string | null | undefined;
  @Input() buttonImageSrc: string;
  @Input() imageAlt: string;
  @Input() navName: string;
  /**
   * Cel ZEWNETRZNY (absolutny URL, np. 'https://drzewowisni.goorder.pl').
   * Historycznie podawany jako tablica jednoelementowa — obie formy dziala.
   */
  @Input() link: any[] | string | null | undefined;
  @Input() showImage = true;
  constructor() {}

  /**
   * Znormalizowany URL zewnetrzny albo null, gdy kafelek jest wewnetrzny.
   *
   * Rozstrzyga, ktora galaz szablonu sie renderuje: link zewnetrzny musi wyjsc
   * jako zwykle <a href>, bo routerLink (dyrektywa Angulara) NADPISUJE attr.href
   * i dla absolutnego URL-a, ktory nie jest trasa routera, zostawial kotwice
   * CALKIEM bez href — kafelek byl martwy dla uzytkownika i niewidoczny dla
   * crawlera.
   */
  get externalHref(): string | null {
    const raw = Array.isArray(this.link) ? this.link[0] : this.link;
    return typeof raw === 'string' && raw.trim() !== '' ? raw : null;
  }
}
